import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/dashboard/admin/sms")({
  head: () => ({ meta: [{ title: "SMS · Admin" }, { name: "robots", content: "noindex" }] }),
  component: () => <Outlet />,
});
